import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'Something went wrong',
  buttonLabel: 'Refresh Page',
  description1: 'We couldn’t load the page due to an unexpected error.',
  description2: 'If the problem persists, please ',
  linkText: 'contact our Support team',
})
